/** True when `a` is the 16-byte id for hex `conversationId` (32 chars). */
export function conversationIdEqual(a: Uint8Array, conversationIdHex: string): boolean {
  const normalized = conversationIdHex.trim().toLowerCase().replace(/-/g, '');
  if (normalized.length !== 32) return false;
  const bytes = new Uint8Array(16);
  for (let i = 0; i < 16; i++) {
    bytes[i] = Number.parseInt(normalized.slice(i * 2, i * 2 + 2), 16);
  }
  return bytesEqual(a, bytes);
}

export function bytesEqual(a: Uint8Array, b: Uint8Array): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}
